"use client";

import * as React from "react";
import { cn } from "@baluu/ui/lib/utils";

type HighlightPriceProps = {
  price: number;
  currency?: string;
  size?: "sm" | "md" | "lg";
  perPerson?: boolean;
  className?: string;
};

const currencySymbols: Record<string, string> = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  AUD: "A$",
  CAD: "C$",
  NZD: "NZ$",
  CHF: "CHF",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  INR: "₹",
  JPY: "¥",
  CNY: "¥",
};

function formatPrice(price: number, currency: string = "GBP"): string {
  const symbol = currencySymbols[currency] || currency + " ";
  // Price is in minor units (cents/pence), divide by 100
  const priceValue = price / 100;
  // Format without decimal places if whole number
  if (priceValue % 1 === 0) {
    return `${symbol}${priceValue}`;
  }
  return `${symbol}${priceValue.toFixed(2)}`;
}

function HighlightPrice({
  price,
  currency = "GBP",
  size = "md",
  perPerson = false,
  className,
}: HighlightPriceProps) {
  const sizeClasses = {
    sm: "text-sm px-2 py-0.5",
    md: "text-base px-2.5 py-1",
    lg: "text-lg px-3 py-1.5",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center font-semibold rounded-md",
        "bg-checkout-success-subtle text-checkout-success-text",
        sizeClasses[size],
        className,
      )}
    >
      {formatPrice(price, currency)}
      {perPerson && " pp"}
    </span>
  );
}

export { HighlightPrice };
export type { HighlightPriceProps };

